/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css } from "@panda/css";

export const richTextContentStyles = css({
	color: "eds.text.secondary",

	"& h1": {
		textStyle: "heading2XL",
	},
	"& h2": {
		textStyle: "headingXL",
	},
	"& h3": {
		textStyle: "headingLG",
	},
	"& h4": {
		textStyle: "headingMD",
	},
	"& h5": {
		textStyle: "headingSM",
	},
	"& h6": {
		textStyle: "eyebrowLG",
	},
	"& p": {
		textStyle: "paragraphLG",
		marginBlockStart: "eds.dimension.4",
		marginBlockEnd: "eds.dimension.24",
	},
	"& strong": {
		color: "eds.text.primary",
	},
	"& h1, & h2, & h3, & h4, & h5, & h6": {
		color: "eds.text.primary",
		marginBlockStart: "eds.dimension.12",
		marginBlockEnd: "eds.dimension.8",
	},
	"& hr": {
		marginBlock: "eds.dimension.32",
		width: "100%",
		borderTopWidth: "1px",
		borderTopStyle: "solid",
		borderTopColor: "eds.border.subtle",
	},
});
